/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { db } from "~/db/db";

const useMapaMinaClienteFechado = ({ clienteId, updateData = true }) => {

  const closedType = useLiveQuery(() => {
    return db.mapaDaMina
    .where('clienteId')
    .equals(clienteId)
    .sortBy('createdAt')
    .then(data => {
      const lastEntry = data.at(-1);

      return lastEntry?.clienteFechado
        ? 'clienteFechado'
        : (lastEntry?.clienteNaoConsomeBasicos ? "clienteNaoConsomeBasicos" : false);
    });
  }, [clienteId]);

  const fechadoConsomeBasico = useLiveQuery(() => {
    if (!closedType) return false;

    return db.mapaDaMinaClienteFechado
      .where('clienteId')
      .equals(clienteId)
      .first()
      .then(data => data?.fechado ?? false);
  }, [clienteId, closedType]);

  const initializeData = async () => {
    if(updateData){
      await db.mapaDaMinaClienteFechado.put({
        clienteId,
        fechado: closedType ?? false
      });
    }
  }

  const open = async () => {
    await db.mapaDaMinaClienteFechado.put({
      clienteId,
      fechado: false,
      tempAberto: true
    });
  }

  useEffect(() => {
    initializeData();
  }, [clienteId, closedType]);

  return {
    fechadoConsomeBasico,
    open
  };
};

export default useMapaMinaClienteFechado;